import { useParams } from 'react-router-dom';
import { createContext } from 'react';

import { useSelectPharmacyById } from 'app/hooks';
import useGetAppointmentById from '../hooks/useGetAppointmentById';

export const AppointmentContext = createContext(null);

export default function AppointmentProvider({ children }) {
  const { appointmentId } = useParams();

  const {
    data: appointment,
    isLoading: isAppointmentLoading,
    isFetched,
    error,
  } = useGetAppointmentById(appointmentId);

  useSelectPharmacyById(appointment?.pharmacyId);

  return (
    <AppointmentContext.Provider value={{ appointment, isAppointmentLoading, isFetched, error }}>
      {children}
    </AppointmentContext.Provider>
  );
}
